<template>
  <!-- 机器视觉 -->
  <div class="scheme_container">
    <div class="scheme_wrap">
      <div class="title_wrap">{{pageData.title}}</div>
      <div class="content_wrap">
        <div class="article_box unify_article">{{pageData.text.text1}}</div>
        &nbsp;
        <div class="img_wrap" v-for="( item, index ) in pageData.imgArr" :key="`${index}-img`">
          <img :src="item.imgSrc" :alt="item.alt">
        </div>
        &nbsp;
        <div class="article_wrap" v-for="( item, index) in pageData.text.textArr" :key="index">
          <div class="subtitle">{{item.textTitle}}</div>
          <div class="text  unify_article" v-for="(itemText, indexText) in item.textContent" :key="`${index}-${indexText}`">
            {{itemText}}
          </div>
          &nbsp;
        </div>
        <div class="article_box unify_article" style="text-indent: 0">{{pageData.text.text2}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        pageData: {
          title: "机器视觉",
          text: {
            text1: "以AI+3D为核心，搭建新一代机器视觉智能编程环境，可视化、无代码的编程界面，一键仿真，实现产品标准化、全场景应用。视觉算法具有精度高、视野大，优异的抗环境光性能。",
            textArr: [
              {
                textTitle: "智能工厂领域",
                textContent:["主要应该包括有瑕疵检测、品质检验、自动化生产辅助等等。"]
              },
              {
                textTitle: "智慧机场领域",
                textContent:[ "主要包括跑道侧鸟类检测驱离、跑道FOD异物检测、建筑物限高检测等。"]
              },
              {
                textTitle: "智慧农业领域",
                textContent: ["主要包括病虫害分析、稻草人驱离等等。"]
              },
              {
                textTitle: "智慧巡检领域",
                textContent: ["主要包括仪器仪表数据读取、线路异常检测、明火、烟雾检测等等。"]
              },
            ],
            text2: "以上领域都具有较为广阔的落地场景，且对于产品而言，架构、逻辑都相同，只需要不同的算法模型，即可实现一个领域或多个领域所需算法的集成。"
          },
          imgArr: [
            {
              imgSrc: require("@/assets/img/solution/pageImg/4_1.jpg"),
              alt: "机器视觉"
            },
            {
              imgSrc: require("@/assets/img/solution/pageImg/4_2.jpg"),
              alt: "机器视觉"
            },
            {
              imgSrc: require("@/assets/img/solution/pageImg/4_3.jpg"),
              alt: "机器视觉"
            },
            {
              imgSrc: require("@/assets/img/solution/pageImg/4_4.jpg"),
              alt: ""
            }
          ]
        }
      }
    }
  }
</script>

<style scoped lang="scss">
@import "@/views/solution/unifyStyle";
.article_wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 0;
  line-height: 2;
  .text {
    text-indent: 0;
    margin-left: 10px;
  }
}
</style>
